<template>
	<div class="leftres">
		<div>
			<div :class=" showorhide ? 'inputtop' : 'inputtops' ">
				<div v-for="(item , index) of formdata" :key="index" style="display: inline-block;">
					<Commondropdownlist ref="uniqueRefs" :lablewith="item.lablewith" :key="index"
						:options="item.options" :inputdata="item.inputdata" :title="item.title"
						:fontSize="item.fontSize" :color="item.color" :placeholder="item.placeholder"
						:types="item.types" :inputtype="item.inputtype" :width="item.width"></Commondropdownlist>
				</div>
				<div :class=" showorhide ? 'Btngroups' : 'Btngroup' ">
					<CommonBtngroup ref="btngroup" :show="showorhide" :chackbox="chackbox" @showclick="showclick"
						@hide="hide" @select="select" @reset="reset"></CommonBtngroup>
				</div>
				<div style="height:10px;">
				</div>
			</div>
			<div class="TableBox"
				style="box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px; background-color: #FFFFFF;">
				<Uniquecodeinventorylisttable :tableData="tableData" :total="total" @Export="Export"
					@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange">
				</Uniquecodeinventorylisttable>
			</div>

		</div>
	</div>
</template>

<script>
	import Commondropdownlist from '../../../components/common-dropdownlist.vue'
	import CommonBtngroup from '../../../components/commongroup.vue'
	import Dialog from '../../../components/dialog.vue'
	import Uniquecodeinventorylisttable from './components/uniquecodeinventorylisttable.vue'
	import utils from '../../../common/utils'
	import {
		StockReportUniqueStockList,
		StockReportUniqueStockExport,
	} from '@/api/home'
	export default {
		components: {
			Commondropdownlist,
			CommonBtngroup,
			Dialog,
			Uniquecodeinventorylisttable
		},
		data() {
			return {
				total: 1,
				pageindex: 1,
				pageSize: 20,
				tableData: [],
				dialogVisibles: false,
				showorhide: true,
				chackbox: true,
				formdata: [{
						inputdata: '',
						title: '经销商类型',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请选择',
						types: '',
						inputtype: 'select',
						width: '220px',
						options: [{
							value: '一级经销商',
							key: '1'
						}, {
							value: '二级经销商',
							key: '2'
						}, ],
						lablewith: '100px'
					},
					{
						inputdata: '',
						title: '经销商名称',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '210px',
						lablewith: '100px'
					},
					{
						inputdata: '',
						title: '仓库编号',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '210px',
						lablewith: '100px'
					},
					{
						inputdata: '',
						title: '仓库名称',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '210px',
						lablewith: '100px'
					},
					{
						inputdata: '',
						title: '批号',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '210px',
						lablewith: '100px'
					},
					{
						inputdata: '',
						title: '唯一码',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '210px',
						lablewith: '100px'
					},
				],
				from: {
					cusGrade: '',
					cusName: '',
					invAddCode: '',
					batch: '',
					invClass: '',
					isAboveZero: '',
				}
			}
		},
		mounted() {
			this.$message.warning("请填写搜索条件！");
			//this.stockReportUniqueStockList()
		},
		methods: {
			// 列表
			async stockReportUniqueStockList() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});

				let {
					data,
					code
				} = await StockReportUniqueStockList({
					cusGrade: this.from.cusGrade,
					cusName: this.from.cusName,
					// invAddCode: this.from.invAddCode,
					batch: this.from.batch,
					// invClass: this.from.invClass,
					isAboveZero: this.from.isAboveZero,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				if (code == 0) {
					this.total = data.Count
					if (data.data) {
						this.tableData = data.data
					}
					loading.close();
				}
				loading.close();
			},
			// 导出
			async stockReportUniqueStockExport() {
				const loading = this.$loading({
					lock: true,
					text: '正在导出...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let resexprot = await StockReportUniqueStockExport({
					cusGrade: this.from.cusGrade,
					cusName: this.from.cusName,
					// invAddCode: this.from.invAddCode,
					batch: this.from.batch,
					// invClass: this.from.invClass,
					isAboveZero: this.from.isAboveZero,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				if (resexprot) {
					let date = new Date()
					let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
					utils.downloadFile(resexprot, `唯一码库存报表${str}`, "xlsx")
					loading.close();
				} else {
					// 返回json
					this.$message.warning('导出失败');
					loading.close();
				}
				loading.close()
			},
			Export() {
				this.stockReportUniqueStockExport()
			},
			reset() {
				this.$refs.uniqueRefs.forEach((item, index) => {
					item.modelvalue = ''
				})
				this.$refs.btngroup.checked = false
			},

			hide() {
				this.showorhide = false
				//console.log("askdas", this.showorhide)

			},
			showclick() {
				this.showorhide = true
			},
			select() {
				this.pageindex = 1
				try {
					this.from.cusGrade = this.$refs.uniqueRefs[0].modelvalue
					this.from.cusName = this.$refs.uniqueRefs[1].modelvalue
					// this.from.invAddCode = this.$refs.uniqueRefs[0].modelvalue
					this.from.batch = this.$refs.uniqueRefs[4].modelvalue
					// this.from.invClass = this.$refs.uniqueRefs[0].modelvalue
					this.from.isAboveZero = this.$refs.btngroup.checkeds ? 1 : 0
					this.stockReportUniqueStockList()
				} catch (error) {
					this.stockReportUniqueStockList()
				}
			},
			handleCurrentChange(pageindex) {
				this.pageindex = pageindex
				this.stockReportUniqueStockList()
			},
			handleSizeChange(paegSzie) {
				this.pageSize = paegSzie
				this.stockReportUniqueStockList()
			},
		},
		watch: {
			showorhide: {
				handler(newVal, oldVal) {
					if (newVal == false) {
						this.chackbox = false
					} else {
						this.chackbox = true
					}
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	.inputtop {
		width: 980px;
		height: 50px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 15px;
		padding-bottom: 70px;
		transition: all 0.3s;
		overflow: hidden;
	}

	.inputtops {
		width: 980px;
		height: 0px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 9px;
		padding-bottom: 64px;
		overflow: hidden;
		position: relative;
		transition: all 0.3s;
	}

	.Btngroup {
		display: inline-block;
		float: right;
		margin-right: 30px;
		width: 300px;
		height: 50px;
		background-color: #ffffff;
		position: relative;
		bottom: 48px;
	}

	.Btngroups {
		display: inline-block;
		float: right;
		margin-top: 5px;
		margin-right: 20px;
	}
</style>
